// extracted by mini-css-extract-plugin
module.exports = {"menu":"header-module--menu--15oJi","menu__box":"header-module--menu__box--371xX","menu__inner":"header-module--menu__inner--2fcoL"};